/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Einvoice_Stuck_Refused_Tax_CodeInputs */

const vi_einvoice_stuck_refused_tax_code = /** @type {(inputs: Einvoice_Stuck_Refused_Tax_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MISA từ chối vì mã số thuế người mua không hợp lệ. Sửa mã số thuế rồi phát hành lại.`)
};

/**

* @param {Einvoice_Stuck_Refused_Tax_CodeInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_stuck_refused_tax_code = /** @type {((inputs?: Einvoice_Stuck_Refused_Tax_CodeInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_Stuck_Refused_Tax_CodeInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_stuck_refused_tax_code(inputs)
});